import React, { useEffect, useState } from "react";
import ProductoList from "../components/ProductoList";
import { useProductStore } from "../hooks";
import {
  handleDecrementProduct,
  handleDeleteRow,
  handleIncrementProduct,
} from "../helpers/useArticulos";
import estadoDespacho from "../api/estadoDespacho";
import MenuSection from "../components/MenuSection";
import { ArticuloKiosk } from "../components/kiosk-components/articulos/articulo-kiosk";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { Detalles } from "../components/kiosk-components/detalles-kiosk/detalles";
import { TotalBar } from "../components/kiosk-components/detalles-kiosk/total-bar";
import { Promociones } from "../components/kiosk-components/detalles-kiosk/promociones";
import { MetodosPagosKiosk } from "../components/kiosk-components/metodos-pagos-kiosk/metodos-pagos-kiosk";
import { generarFacturaInfo } from "../helpers/generarFacturaInfo";

export const DetallesKioskPage = () => {
  const isYPF = localStorage.getItem("bandera") === "ypf";
  const theme = useTheme();
  const navigate = useNavigate();
  const [total, setTotal] = useState(0);
  const [habilitarButton, setHabilitarButton] = useState(isYPF ? true : false);
  const [visibleBotonPagos, setVisibleBotonPagos] = useState(isYPF);
  const [irMetodoDePago, setIrMetodoDePago] = useState(false);
  const [metodoPagoSeleccionado, setMetodoPagoSeleccionado] = useState(isYPF ? 1 : null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const factura = consumidorFinal => {
    const cliente = consumidorFinal ? null : { idCliente: 1 };
    const facturaInfo = generarFacturaInfo(productos, cliente);
    localStorage.setItem("facturaInfo", JSON.stringify(facturaInfo));
    if(!isYPF){
      setIrMetodoDePago(true);
    }
  };

  // Función para manejar el pago según el método seleccionado
  const handlePagar = () => {
    if (!metodoPagoSeleccionado) return;

    // Mapeo de IDs a métodos de pago
    const metodosMap = {
      1: "ypf", // App YPF
      2: "mercadopago", // Mercado Pago
      3: "modo", // Modo
      4: "credito", // Tarjeta de Crédito
      5: "debito", // Tarjeta de Débito
      6: "efectivo", // Efectivo al vendedor
    };

    const medioDePago = metodosMap[metodoPagoSeleccionado];
    const totalFormateado = Number(total).toLocaleString("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Navegar a la pantalla de procesamiento de pago
    navigate(
      `/pagokioskpage?metodoPago=${medioDePago}&total=${totalFormateado}`,
    );
  };

  const { productos, clearProductos, updateProducto } = useProductStore();

  const calcularTotal = () => {
    let sumaTotal = 0;
    productos.forEach(producto => {
      sumaTotal += producto.importe;
    });
    setTotal(sumaTotal);
  };

  const handleDelete = (id, descripcion) => {
    setItemToDelete({ id, descripcion });
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    if (itemToDelete) {
      handleDeleteRow(itemToDelete.id, productos, updateProducto);
    }
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  };

  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  };

  useEffect(() => {
    // Solo habilitar el botón si estamos en métodos de pago Y hay uno seleccionado
    // O si no estamos en métodos de pago (pantalla anterior)
    if (irMetodoDePago) {
      setHabilitarButton(metodoPagoSeleccionado !== null);
      setVisibleBotonPagos(true);
    } else {
      setHabilitarButton(false);
      setVisibleBotonPagos(false);
    }
  }, [irMetodoDePago, metodoPagoSeleccionado]);

  useEffect(() => {
    calcularTotal();
  }, [productos]);

  useEffect(() => {
    if(isYPF){
      factura(true);
      setVisibleBotonPagos(true);
      setHabilitarButton(true);
      setMetodoPagoSeleccionado(1);
    }
  }, []);

  return (
    <>
      <MenuSection />
      <Grid container direction="column" sx={{ height: "90vh", mt: 15 }}>
        {irMetodoDePago ? (
          <MetodosPagosKiosk
            metodoPagoSeleccionado={metodoPagoSeleccionado}
            setMetodoPagoSeleccionado={setMetodoPagoSeleccionado}
          />
        ) : (
          <Detalles
            productos={productos}
            isYPF={isYPF}
            factura={factura}
            handleDelete={handleDelete}
            handleIncrease={id =>
              handleIncrementProduct(id, productos, updateProducto)
            }
            handleDecrease={id =>
              handleDecrementProduct(id, productos, updateProducto)
            }
          />
        )}

        <IconButton
          onClick={() =>
            irMetodoDePago
              ? setIrMetodoDePago(false)
              : navigate("/tiendakioskpage", {state: { vieneDeDetalles: true }})
          }
          sx={{ mr: 10, position: "absolute", bottom: "32.5rem", left: "2rem" }}
        >
          <ArrowCircleLeftIcon
            sx={{ fontSize: 60, color: theme.bandera.colorSecundario }}
          />
        </IconButton>
        <Grid item sx={{ flex: 0.5, mb: 1 }}>
          <Box
            sx={{
              p: 3,
              backgroundColor: "#fff",
              borderRadius: 1,
              height: "110px",
            }}
          >
            <TotalBar
              total={total}
              habilitarButton={habilitarButton}
              onPagar={handlePagar}
              visibleBotonPagos={visibleBotonPagos}
            />
          </Box>
        </Grid>
        <Promociones />
      </Grid>

      {/* Dialog de confirmación para eliminar */}
      <Dialog open={openDeleteDialog} onClose={handleCancelDelete}>
        <DialogContent sx={{mt: 4}}>
          <Typography variant="h4">
            ¿Estás seguro de que deseas eliminar "{itemToDelete?.descripcion}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelDelete}
            sx={{ fontSize: 20, color: theme.bandera.colorSecundario, mr: 2 }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmDelete}
            sx={{ fontSize: 20, bgcolor: theme.bandera.colorSecundario, m: 2 }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
